/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Authcallbackerrorbody3Inputs */

const en_authcallbackerrorbody3 = /** @type {(inputs: Authcallbackerrorbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The link may have expired or already been used. Please request a new one.`)
};

const pt_authcallbackerrorbody3 = /** @type {(inputs: Authcallbackerrorbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O link pode ter expirado ou já ter sido usado. Solicite um novo.`)
};

/**
* | output |
* | --- |
* | "The link may have expired or already been used. Please request a new one." |
*
* @param {Authcallbackerrorbody3Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const authcallbackerrorbody3 = /** @type {((inputs?: Authcallbackerrorbody3Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Authcallbackerrorbody3Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_authcallbackerrorbody3(inputs)
	return pt_authcallbackerrorbody3(inputs)
});
export { authcallbackerrorbody3 as "authCallbackErrorBody" }